import React, { Component } from 'react';
import './style.css';

export default class VerticalSeparator extends Component {

  componentDidMount = () => {
      window.addEventListener('scroll', this.handleOnScroll)
  }

  componentWillUnmount = () => {
      window.removeEventListener('scroll', this.handleOnScroll)
  }

  handleOnScroll = (event) => {
    var diff = (this.refs.scrollIndicator.getBoundingClientRect().top - window.innerHeight)
    var elementHeight = this.refs.scrollIndicator.getBoundingClientRect().height
    if (diff < (-1 * elementHeight / 2) && diff > (-1.5 * elementHeight) ) {
      var change = diff + ((elementHeight / 2))
      this.refs.toBeScrolled.style.transform = `translate(0px, ${-1 * change}px)`
    } else if (diff > (-1 * elementHeight / 2)) {
      this.refs.toBeScrolled.style.transform = `translate(0px, 0px)`
    } else {
      this.refs.toBeScrolled.style.transform = `translate(0px, ${elementHeight}px)`
    }
  }


  render() {
    return (
      <section className="pa5 z-999 w-100 flex flex-row justify-center">
        <div className="relative vh-25" ref="scrollIndicator">
          <div className="moving-dot absolute top-0 z-1" ref="toBeScrolled">
          </div>
          <div className="stick absolute bottom-0 z-0">
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/general/Decorations/VerticalSeparator/index.jsx